import { defineComponent as _defineComponent } from 'vue'
import ButtonComponent from "./ButtonComponent.vue"

interface ConfirmModalProps {
  mainTitle: string
  subTitle: string
  yesTitle: string
  noTitle: string
  yesButtonColorClass: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ConfirmModal',
  props: {
    mainTitle: { default: "Are you sure?" },
    subTitle: { default: "Are you sure?" },
    yesTitle: { default: "Yes" },
    noTitle: { default: "No" },
    yesButtonColorClass: { default: "" }
  },
  emits: ["confirm", "cancel"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();



const emit = __emit

const onConfirm = () => {
  emit("confirm")
}

const onCancel = () => {
  emit("cancel")
}

const __returned__ = { emit, onConfirm, onCancel, ButtonComponent }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})